import { BoxProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'
export const styles = {
  checkboxFixes: {
    marginRight: 10,
    marginTop: 3,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    paddingVertical: 10,
  } as BoxProps,
  child: {
    minWidth: 200,
    paddingVertical: 15,
    marginLeft: -8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    underlayColor: 'WHITE',
  } as BoxProps,
  topBar: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingBottom: 10,
    paddingHorizontal: 16,
    marginHorizontal: -16,
    borderBottomWidth: 1,
    borderBottomColor: Colors.GREY_BORDER,
  } as BoxProps,
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 12,
  } as BoxProps,
  resetContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 12,
  } as BoxProps,
  bottomBar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap-reverse',
    paddingHorizontal: 16,
    marginHorizontal: -16,
    marginBottom: -12,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: Colors.GREY_BORDER,
  } as BoxProps,
  outerContainer: {
    borderWidth: 1,
    borderColor: Colors.GREY_BORDER,
    padding: 16,
    borderRadius: 8,
    marginTop: 20,
    backgroundColor: 'WHITE',
  } as BoxProps,
}
